import { userRepository } from '../repositories/user-repository';

async function saveOnboardingStep({ stepNumber, onboardingType, isFinished = false }) {
    if (stepNumber < 0 || !onboardingType) {
        throw Error('Cannot save onboarding step');
    }

    return userRepository.saveOnboarding({ stepNumber, onboardingType, isFinished });
}

export {
    saveOnboardingStep
};
